import { Button, ButtonProps } from "@chakra-ui/react"
import { useFormikContext } from "formik"

export function useIsSubmissionDisabled(): boolean {
  const form = useFormikContext()
  return form
    ? form.isSubmitting ||
        !form.isValid ||
        (!form.dirty && !form.validateOnMount)
    : true
}

const SubmitButton = (props: ButtonProps): JSX.Element => {
  const form = useFormikContext()
  const isSubmissionDisabled = useIsSubmissionDisabled()

  return (
    <Button
      variant="solid"
      colorPalette="brand"
      type="submit"
      width="full"
      loading={form.isSubmitting}
      disabled={isSubmissionDisabled}
      {...props}
    />
  )
}

export default SubmitButton
